<template>
  <v-container fluid class="py-0 open-position--page" :style="'height:' + computedPageHeight + 'px'">

    <v-row>
      <v-col
        class="pa-0">

        <!-- hero -->
        <v-card flat dark>
          <v-img
            id="img-main"
            src="@/assets/img/about-company-04.jpeg"
            class="grey lighten-2"
            cover
            :max-height="computedPageHeight"
            :style="'height:' + 300 + 'px'">
            <v-row
              class="fill-height overlay mx-0"
              align="center"
              justify="center">
              <v-col class="">
                <!-- <v-row>
                  <v-col class="text-center">
                    <span class="mr-4 subsite-title-1" style="line-height:6rem;">{{ $t('rubin.rubin') }}</span>
                    <span class="subsite-title-2" style="line-height:3rem;">{{ $t('career.title') }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center subsite-title-3">
                    {{ $t("career.subtitle") }}
                  </v-col>
                </v-row> -->
              </v-col>
            </v-row>

            <!-- ic img -->
            <v-row class="carousel-bottom-controls">
              <v-col class="pa-0 img-ic-box flip-x">
              </v-col>
            </v-row>

          </v-img>
        </v-card>

        <!-- main content -->
        <v-row class="max-width-1200 mx-auto pt-6">
          <v-col cols="12" sm="8" md="9">
            <v-row class="mx-1">
              <v-col id="title" class="pb-2">
                <h1>{{ content.title}}</h1>
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col id="desciption" class="pt-0">
                <p style="font-size:1.3rem;font-weight:300;margin-bottom:8px;">{{ content.description}}</p>
                <p>{{ content.text}}</p>
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col cols="12" md="6" id="skills">
                <h2>Mi különböztet meg Téged másoktól?</h2>
                <h3>Szakmailag</h3>
                <p>
                  <ul class="text-list">
                    <li
                      v-for="(item, index) in content.skills"
                      :key="index">
                        {{ item }}
                    </li>
                  </ul>
                </p>
                <!-- traits -->
                <h3>Emberileg</h3>
                <p>
                  <ul class="text-list">
                    <li
                      v-for="(item, index) in content.traits"
                      :key="index">
                        {{ item }}
                    </li>
                  </ul>
                </p>
                <!-- advantages -->
                <h3>Előnyt jelent</h3>
                <p>
                  <ul class="text-list">
                    <li
                      v-for="(item, index) in content.advantages"
                      :key="index">
                        {{ item }}
                    </li>
                  </ul>
                </p>
              </v-col>
              <v-col cols="12" md="6" id="challanges">
                <h2>Milyen kihívások várnak Rád?</h2>
                <p>
                <ul class="text-list">
                  <li
                    v-for="(item, index) in content.challenges"
                    :key="index">
                      {{ item }}
                  </li>
                </ul>
              </p>
              <!-- <h2>Mit várhatsz el tőlünk?</h2>
                <p>
                <ul class="text-list">
                  <li
                    v-for="(item, index) in content.ourSide"
                    :key="index">
                      {{ item }}
                  </li>
                </ul>
              </p> -->
              </v-col>
            </v-row>
          </v-col>

          <!-- info card -->
          <v-col cols="12" sm="4" md="3">
            <v-card>
              <v-row class="mx-1">
              <v-col id="title">
                <h2 class="headline-2">
                Csatlakozz csapatunkhoz!
                </h2>
                <p class="text-left" style="font-size: .8rem;">
                  Jelentkezésed várjuk a <strong class="fontcolor-primary mouse-hover-link" @click="openMail('karrier@rubin.hu')">karrier@rubin.hu</strong> címen.
                </p>
                <p style="font-size: .8rem; line-height: 1.4rem;">
                  <v-icon class="mx-2" small>mdi-clock</v-icon>Teljes munkaidő<br>
                  <v-icon class="mx-2" small>mdi-home-city</v-icon>Otthoni és irodai<br>
                  <v-icon class="mx-2" small>mdi-file-document</v-icon>Határozatlan idejű<br>
                </p>
                <p style="font-size: .8rem;">
                  Önéletrajzod mindenképpen csatold. Motivációs leveled, fotód, és okleveleid beküldésével gyorsíthatod a kiválasztás folyamatát!
                </p>
              </v-col>
            </v-row>
            </v-card>

            <!-- back -->
            <v-row class="mx-0">
              <v-col id="download" cols="12" class="text-end px-0 pb-0">
                <v-btn
                  text small
                  @click="downloadItem(fileSuffix)">
                    Letöltés PDF-ben
                </v-btn>
              </v-col>
              <v-col id="back" cols="12" class="text-end px-0 pt-0">
                <v-btn
                  color="primary"
                  text small
                  @click="loadPage('Career')">
                    Vissza a karrier oldalra
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

    <v-row class="bg-ruby">
      <v-col>
        <Contact></Contact>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import AppBarMenu from '@/components/Common/AppBar.vue';
  import DataComponentBase from '@/commons/DataComponentBase';

  import Contact from '@/components/Common/Contact.vue'

  export default {
    name: 'InstallationManager',
    metaInfo: {
      title: 'Telepítésvezető',
      titleTemplate: '%s - Rubin Informatika',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Karrier lehetőség a Rubin Informartikánál, mint telepítésvezető, projektvezető mérnök. Megbecsülünk és számítunk rád. Csatlakozz a Rubin csapatához!'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Rubin Informatika, IT, karrier, nyitott pozíció, munka, lehetőség, telepítésvezető, projektvezető mérnök'
        }
      ],
      __dangerouslyDisableSanitizers: ['meta'],
    },

    extends: DataComponentBase,

    components: {
      AppBarMenu,
      Contact,
    },

    data: () => ({
      fileSuffix: 'Telepitesvezeto',
      content: {
        icon: 'mdi-progress-wrench',
        title: 'Telepítésvezető, projektvezető mérnök',
        description: 'Jelenleg új telepítésvezető, projektvezető mérnök kollégával szeretnénk bővíteni csapatunkat, aki hisz abban, hogy munkájával értéket is teremt.',
        text: 'A Rubin Informatikai Zrt. automatizálási és mérési rendszerek fejlesztésével és telepítésével foglalkozik Magyarország teljes területén igényes ipari megrendelők részére. Budapesti irodánkba, esetenként külső helyszíni munkavégzéssel keresünk kollégát.',
        challenges: [
          'mérési és automatizálási rendszerek feladatainak felmérése',
          'a megoldás tervezése',
          'mérőrendszerek helyszíni telepítésének irányítása',
          'önálló, felelősségteljes döntési helyzetek',
        ],
        skills: [
          'felsőfokú (villamos) műszaki diploma',
          'önálló munkavégzés a tervezés és a kivitelezés irányítása terén',
          'asszertív kommunikáció a kollégákkal és az alvállalkozókkal',
          'fejlett problémamegoldó és kezdeményezőképesség',
          'dokumentációk, tervek készítése számítógéppel',
          'üzemeltetési és esetleg tervezési gyakorlat épületgépészet, klimatizálás, villamos rendszerek, automatizálás, mérés és adatgyűjtés területeken',
          'idegennyelv-ismeret',
          'számítógép kezelői ismeretek',
          'MS office és OpenOffice alkalmazások felhasználói ismerete',
        ],
        traits: [
          'precíz és alapos, mégis hatékony vagy',
          'iránymutatás mentén önállóan dolgozol',
          'kreatív ötletekkel rendelkezel, amiket meg is valósítasz',
          'a stabilitás és a kiszámíthatóság fontos számodra',
          'innovatív és környezettudatos termékek fejlesztésében szeretnél részt venni',
        ],
        advantages: [
          'Linux rendszer ismereted van',
          'villanyszerelési ismereted és gyakorlatod van',
          'angol nyelvtudásod van',
        ],
        ourSide: [
          'stabil, kiszámítható munkahelyet: voltunk, vagyunk és leszünk',
          'innovatív csapatot, izgalmas projektek, ahol a szakmai flow átélhető',
          'korrekt, teljesen bejelentett, határozatlan idejű munkaviszonyt',
          '5×8 órás munkaidő budapesti munkahelyen, időnként munkavégzés külső helyszínen az ország területén',
          'törekszünk a munka-magánélet egyensúlyának megteremtésére',
          'családias, befogadó környezetet, mert mi odafigyelünk egymásra',
          'számunkra az egyéniség érték. Nálunk önmagad lehetsz!',
          'home office eseti lehetőségét',
          'vezetőink közvetlenek, elérhetőek és ajtajuk nyitva áll a munkatársak előtt.',
        ],
      },
    }),

    mounted() {
    },

    computed: {
      mini() {
        if (this.computedWidth < 800) {
          return true
        } else {
          return false
        }
      },

    },

    methods: {
      openMail(email) {
        window.location ='mailto:' + email;
      },
      downloadItem(position) {
        let url = './' + position + '_hirdetes_2023.pdf'
        let label = 'Rubin_' + position + '_hirdetes_2023'
        window.open(url)
      },
    },

    watch: {
    },
  }

</script>

<style src="../../Style.css">
</style>